import React, { CSSProperties } from 'react';
// import PropTypes from 'prop-types';
import { dayOfMonthShort, dayOfWeek } from '@firsttable/functions/src/dateWithDayJs';
import { Availability } from '@firsttable/types';
import Box from '@firsttable/web-components/atoms/Box';
import PriceRating from '@firsttable/web-components/molecules/PriceRating';
import styled from 'styled-components';
import Link from '@firsttable/web-components/atoms/Link';
import Flex from '@firsttable/web-components/atoms/Flex';
import BodyTitle from '@firsttable/web-components/atoms/BodyTitle';
import Text from '@firsttable/web-components/atoms/Text';
import Divider from '@firsttable/web-components/atoms/Divider';
import { TrackProvider } from '@/components/analytics/context/AnalyticsContext';
import { RestaurantHeroImage } from '../RestaurantHero/RestaurantHeroComponents';

const textOverflowHiddenStyles: CSSProperties = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export interface ListItemCardProps {
  item: any;
  subTitle?: string;
  width?: number;
  img?: { url: string; [key: string]: any };
  dataImg?: null;
  isLoading?: boolean;
  availability: Availability[];
  forwardedRef?: React.Ref<any>;
  NavComponent: React.ReactNode;
}

const RestaurantHeroImageWrapper = styled(Box)`
  > span {
    height: 100% !important;
  }
  img {
    object-fit: cover;
  }
`;

const ListItemCard = ({
  item,
  subTitle,
  width = 285,
  img,
  dataImg,
  isLoading,
  availability,
  forwardedRef,
  NavComponent,
}: ListItemCardProps) => {
  const imgHeight = 240;
  return (
    <Box width={width} colors="card.s" position="relative" ref={forwardedRef}>
      <RestaurantHeroImageWrapper bg="#ebeff2" height={imgHeight}>
        {img && <RestaurantHeroImage src={img.url} alt={item.title} />}
      </RestaurantHeroImageWrapper>
      <Box p="20px 25px">
        <Flex>
          <BodyTitle size="xs" m={0} style={{ flex: 1, ...textOverflowHiddenStyles }}>
            <TrackProvider link_name="restaurant">
              <Link NavComponent={NavComponent} to={item.slug} expandClickableArea>
                {item.title}
              </Link>
            </TrackProvider>
          </BodyTitle>
          {item.price && (
            <Box ml="20px">
              <PriceRating rating={item.price} />
            </Box>
          )}
        </Flex>
        <Text
          fontSize="xs"
          lineHeight="xs"
          color="grayscale.600"
          style={{ ...textOverflowHiddenStyles }}>
          {subTitle || <span>&nbsp;</span>}
        </Text>
        {availability && (
          <Flex justifyContent="space-between">
            {isLoading ? (
              <Box bg="grayscale.300" width="100%" height="24px" mb="xs" mt="xs" />
            ) : (
              Object.keys(availability)
                .slice(0, 7)
                .map((key: any) => {
                  const day = availability[key];
                  const dateKey = day.id || item.id;
                  return (
                    <Box key={dateKey} width="27px" textAlign="center">
                      <Text color="grayscale.600" mb="3px" fontSize="xxs" lineHeight="xxs">
                        {dayOfWeek(`${day.date}`)}
                      </Text>
                      <Divider />
                      <Text
                        mb={0}
                        fontSize="xs"
                        lineHeight="xs"
                        color={day.available ? 'black' : 'grayscale.600'}>
                        <strong>{dayOfMonthShort(`${day.date}`)}</strong>
                      </Text>
                    </Box>
                  );
                })
            )}
          </Flex>
        )}
      </Box>
    </Box>
  );
};

export default ListItemCard;
